import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";

interface Props {
  text: string;
  icon: ReactNode;
}

const InfoBox: React.FC<Props> = (props) => {
  const { text, icon } = props;

  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={3}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: theme.palette.background.default,
        paddingY: { xs: 5, md: 7 },
        paddingX: { xs: 2, md: 7 },
        borderRadius: 2,
        fontSize: 60,
        width: "100%",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{ flexShrink: 0, alignItems: "center" }}
        color={theme.palette.tertiary.main}
      >
        {icon}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          alignItems: "center",
          flexGrow: 1,
          flexShrink: 1,
          minWidth: "0",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoBox;
